import MessageCopiesViewedChart from "./MessageCopiesViewedChart";

export default MessageCopiesViewedChart